"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = authorize;
var AUTHORIZE_ENDPOINT = "https://auth-backend-wem7woj65q-ew.a.run.app/authorization";
var AUTHORIZE_ENDPOINT_DEV = "https://auth-backend-4c5wwacrwq-ew.a.run.app/authorization";
function authorize(idToken, application, dev) {
  if (!idToken || !application) throw "IdToken or Application must be specified";
  var headers = new Headers({
    Authorization: "Bearer ".concat(idToken),
    application: application
  });
  return fetch(dev ? AUTHORIZE_ENDPOINT_DEV : AUTHORIZE_ENDPOINT, {
    headers: headers,
    method: "GET",
    cache: "default",
    mode: "cors"
  }).then(function (response) {
    if (!response.ok) {
      return response.json().then(function (message) {
        throw message;
      });
    }
    return response.json();
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@perfweb/auth-lib/lib/authorizations.js
// module id = jesT
// module chunks = 5